import { Banner } from 'component/Banner/Banner'
import { useLatestCallback } from 'hook/useLatestCallback'
import { i18n } from 'i18n'
import { observer } from 'mobx-react-lite'
import { ActionsContent } from 'shared/inference/ActionsContent'
import { store } from 'store/store'

type Props = {
  fullscreen?: boolean
}

export const ActionsBanner = observer(({ fullscreen }: Props) => {
  const inference = store.fullscreen?.inferences?.item ?? store.carousel?.carousel.item
  const open = store.carousel?.actions

  const onCancel = useLatestCallback(async () => {
    store.carousel.actions = false
  })

  if (!inference || !open) return null

  return <Banner title={i18n('Outfit')} onCancel={onCancel} fullscreen={fullscreen}>
    <ActionsContent inference={inference} />
  </Banner>
})
